<template>
    <div>
        <div id="big" v-if="record.user.name">
            <div class="bigContainer">
                <div class="modal fade" id="updateRecord" tabindex="-1" role="dialog"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title bold" id="exampleModalLabel"><i
                                        class="fa-solid fa-pen-to-square"></i> Chỉnh sửa Hóa đơn</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="text-danger"><i
                                            class="fa-regular fa-circle-xmark"></i></span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="updateRecord()">
                                    <div class="row">
                                        <div class="form-group col-6">
                                            <label class="bold">Doanh thu thực (VNĐ)</label>
                                            <input v-model="record.revenue" type="text"
                                                class="form-control form-control-sm" id="exampleInputEmail1"
                                                aria-describedby="emailHelp" placeholder="1.000.000 (VNĐ)">
                                            <span v-if="errors.revenue" class="text-danger">{{ errors.revenue[0]
                                                }}<br></span>
                                        </div>
                                        <div class="form-group col-6">
                                            <label class="bold">VAT (%)</label>
                                            <input v-model="record.vat_percentage" type="text"
                                                class="form-control form-control-sm" id="exampleInputEmail1"
                                                aria-describedby="emailHelp" placeholder="8 (%)">
                                            <span v-if="errors.vat_percentage" class="text-danger">{{ errors.vat_percentage[0]
                                                }}<br></span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-12">
                                            <label class="bold">Ghi chú</label>
                                            <div class="col-12 p-0">
                                                <textarea class="col-12" name="" id="" v-model="record.note"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn-pers" id="login_button"><i
                                            class="fa-solid fa-paper-plane"></i> Cập nhật</button>
                                </form>
                                <p><label for="exampleInputEmail1"><strong>Tên Học viên</strong></label> : {{
                                    record.user.name }}</p>
                                <p><label for="exampleInputEmail1"><strong>Email Học viên</strong></label> : {{
                                    record.user.email }}</p>
                                <div class="mb-2 mt-2 infor-revenue">
                                    <span><i class="fa-solid fa-coins"></i> Doanh thu thực: <span
                                            class="text-primary">{{
                                                this.$formatNumber(record.revenue) }} VNĐ</span> </span>
                                    <span class="ml-3"><i class="fa-solid fa-coins"></i> VAT: <span
                                            class="text-danger">{{
                                                this.$formatNumber(record.vat_percentage) }} (%)</span></span>
                                    <span class="ml-3"><i class="fa-solid fa-coins"></i> VAT: <span
                                            class="text-danger">{{
                                                this.$formatNumber(record.revenue * record.vat_percentage / 100) }} VNĐ</span></span>
                                    <span class="ml-3"><i class="fa-solid fa-coins"></i> Lợi nhuận: <span
                                            class="text-success">{{ this.$formatNumber(record.revenue - (record.revenue * record.vat_percentage / 100)) }}
                                            VNĐ</span></span>
                                </div>
                                <div><strong>Danh sách khóa học trong hóa đơn này</strong></div>
                                <div class="pl-3 container-list-course">
                                    <li class="list-name-course" v-for="(name_course, index) in record.name_courses"
                                        :key="index">{{
                                            name_course }}</li>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserRequest from '@/restful/UserRequest';

export default {
    name: "UpdateRecord",
    setup() {

    },
    props: {

    },
    data() {
        return {
            record: {
                id: null,
                user: {
                    name: null,
                    email: null,
                },
                revenue: 0,
                vat_percentage: 0,
                vat_amount: 0,
                profit: 0,
                name_courses: [],
                note: '',
                created_at: null,
                updated_at: null,
            },
            errors: {
                id: null,
                description: null,
                category_name: null,
            }
        }
    },
    mounted() {
        this.$onEvent('eventSelectedRecord', (recordSelected) => {
            this.record = { ...recordSelected };
        });
    },
    created() {

    },
    components: {

    },
    computed: {

    },
    methods: {
        updateRecord: async function () {
            try {
                const { messages } = await UserRequest.post(`admin/invoice/update/${this.record.id}`, this.record, true);
                this.$emitEvent('eventSuccess', messages[0]);
                for (let key in this.errors) this.errors[key] = null;
                var closePW = window.document.getElementById('updateRecord');
                closePW.click();
                this.$emitEvent('eventRegetDataRecords', '');
            }
            catch (error) {
                if (error.errors) this.errors = error.errors;
                else for (let key in this.errors) this.errors[key] = null;
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }

        },
    },
    watch: {

    },
}
</script>

<style scoped src="@/components/modal-responsive.css"></style>
<style scoped>

textarea {
    border: 1px solid silver;
    padding: 10px;
}

.container-list-course {
    max-height: 40vh;
    overflow: hidden;
    overflow-y: scroll;
}

.list-name-course {
    list-style: auto;
}

/*  */
.modal-dialog {
    max-width: 1000px;
}

/*  */
.modal.fade.show {
    padding-left: 0px;
}

.modal-content {
    /* margin-top: 100px; */
    border-radius: 10px;
}

.bigContainer .input-form {
    height: 40px;
    width: 100%;
    position: relative;
}

.bigContainer .input-form input {
    height: 100%;
    width: 100%;
    border: none;
    font-size: 17px;
    border-bottom: 2px solid silver;
    outline: none !important;
}

.input-form input:focus~label,
.input-form input:valid~label {
    transform: translateY(-20px);
    font-size: 15px;
    color: var(--user-color);
}

.input-form .underline.fix2:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.bigContainer .input-form label {
    position: absolute;
    bottom: 0px;
    left: 0;
    color: grey;
    pointer-events: none;
    transition: all 0.3s ease;
}

.input-form .underline {
    position: absolute;
    height: 2px;
    width: 100%;
    bottom: 0;
}

.input-form .underline:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.input-form input:focus~.underline:before,
.input-form input:valid~.underline:before {
    transform: scaleX(1);
}

@import url('https://fonts.googleapis.com/css2?family=Reem+Kufi+Ink');

#big {
    display: flex;
    position: relative;
}

.btn-pers {
    position: relative;
    left: 50%;
    padding: 1em 2.5em;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    font-weight: 700;
    color: #000;
    background-color: #fff;
    border: none;
    border-radius: 45px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
    transform: translateX(-50%);
}

.btn-pers:hover {
    background-color: var(--user-color);
    box-shadow: var(--btn-hover);
    color: #fff;
    transform: translate(-50%, -7px);
}

.btn-pers:active {
    transform: translate(-50%, -1px);
}

#inputPassword {
    padding-right: 26px;
}
</style>
